import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["proFields"]

  toggle(event) {
    const isPro = event.target.value === "business"
    this.proFieldsTarget.classList.toggle("hidden", !isPro)
  }
}
